import { render, staticRenderFns } from "./OperatingStatistics.vue?vue&type=template&id=27787d05&scoped=true"
import script from "./OperatingStatistics.vue?vue&type=script&lang=js"
export * from "./OperatingStatistics.vue?vue&type=script&lang=js"
import style0 from "./OperatingStatistics.vue?vue&type=style&index=0&id=27787d05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27787d05",
  null
  
)

export default component.exports